import React, { FC } from 'react';

import styled from 'styled-components';

// constants
import aampeTheme from '../../../constants/aampeTheme';

//components
import BasicChip from '../../display/chips/basicChip';

interface FilterDisplayProps {
    displayFilters: any[];
    clearFilters: (columnId: string, value: string) => void;
    setFieldValue: (
        field: string,
        value: any,
        shouldValidate?: boolean,
    ) => void;
    clearAllFilters: () => void;
    className?: string;
}
const FilterDisplay: FC<React.PropsWithChildren<FilterDisplayProps>> = ({
    displayFilters,
    clearFilters,
    setFieldValue,
    clearAllFilters,
    className,
}) => {
    return (
        <Container className={className}>
            {displayFilters.map((column) => (
                <BasicChip
                    key={`${column.columnId}_${column.value}`}
                    title={column.label}
                    onClickHandler={() => {
                        const newValues = displayFilters
                            .filter(
                                (filter) =>
                                    filter.columnId === column.columnId &&
                                    column.value !== filter.value,
                            )
                            .map((filter) => filter.value);
                        clearFilters(column.columnId, column.value);
                        setFieldValue(column.columnId, newValues);
                    }}
                />
            ))}
            <ClearFiltersButton onClick={clearAllFilters}>
                Clear all
            </ClearFiltersButton>
        </Container>
    );
};

export default FilterDisplay;

const Container = styled.div({
    display: 'flex',
    alignItems: 'center',
    gap: aampeTheme.spacing4(2),
    flexWrap: 'wrap',
    marginLeft: `-364px`,
    '@media (max-width: 1439px)': {
        marginLeft: `-304px`,
    },
});

const ClearFiltersButton = styled.div({
    color: aampeTheme.colors.solidA01,
    fontSize: '16px',
    fontWeight: 500,
    lineHeight: '18px',
    cursor: 'pointer',
    alignSelf: 'center',
});
